import { ReactNode, useEffect } from 'react';
import { useThemePreference } from '../context/ThemePreferenceContext';
import { syncTelegramThemeCssVars } from '../theme/cssVars';

export function AppShell({ children }: { children: ReactNode }) {
  const { resolvedColorScheme } = useThemePreference();

  useEffect(() => {
    syncTelegramThemeCssVars();
  }, [resolvedColorScheme]);

  return <div className="app-shell">{children}</div>;
}
